import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {ApiProvider} from "../../providers/api/api";

/**
 * Generated class for the AppFeedbackPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-feedback',
  templateUrl: 'app-feedback.html',
})
export class AppFeedbackPage {
  feedbackText: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, private api: ApiProvider) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppFeedbackPage');
  }

  sendFeedback() {
    if(!this.feedbackText) {
      return ;
    }

    this.api.callPost('/feedback', {feedback: this.feedbackText}).subscribe();

    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/app-feedback/app-feedback.ts